module.exports = __webpack_public_path__ + "img/contact-item2.56d87f13.png";